import { CLICKSTREAM_ERROR_EVENT } from '../service/clickStream.constant';

export const API_STATUS_CODE = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  ACCEPTED: 202
};

export const responseStatus = {
  SERVER_ERROR: { min: 500, max: 599, eventName: CLICKSTREAM_ERROR_EVENT.SERVER_ERROR },
  CLIENT_ERROR: { min: 400, max: 499, eventName: CLICKSTREAM_ERROR_EVENT.CLIENT_ERROR },
  REDIRECTION: { min: 300, max: 399, eventName: CLICKSTREAM_ERROR_EVENT.REDIRECTION },
  CORS: { min: -1, max: 1, eventName: CLICKSTREAM_ERROR_EVENT.CORS_ERROR }
};

export const commonErrorObject = {
  response: {
    data: {
      message: '{"message":"Something went wrong"}'
    }
  }
};

export type ApiExperiencePayload = {
  latency: number;
  url: string;
  status: number;
  idempotencyKey: string | undefined;
};

export const API_LATENCY_THRESHOLD = 15e3;
